/**
 * Created by filatov on 16.09.2015.
 */
import LeaveHTMLPreviewBaseColumnsStrategy from './LeaveHTMLPreviewBaseStrategy'

export default function LeaveHTMLPreviewTimeOnlyStrategy() {}

LeaveHTMLPreviewTimeOnlyStrategy.prototype = new LeaveHTMLPreviewBaseColumnsStrategy();

LeaveHTMLPreviewTimeOnlyStrategy.prototype.init = function( timeFormat )
{
    LeaveHTMLPreviewBaseColumnsStrategy.prototype.init.call( this, timeFormat );
    return this;
};

LeaveHTMLPreviewTimeOnlyStrategy.prototype.addFirstHeaderRowCells = function( firstHeaderRow )
{
    this.addCreatedCell( firstHeaderRow, this.createTotalLeaveTimeCell());
    this.addCreatedCell( firstHeaderRow, this.createLeaveHeaderCell() );
    this.addCreatedCell( firstHeaderRow, this.createLeaveHeaderCell() );
    this.addCreatedCell( firstHeaderRow, this.createLeaveHeaderCell() );
};

LeaveHTMLPreviewTimeOnlyStrategy.prototype.addDataCells = function( row )
{
    this.addTimeValueCell(row);
    this.addTimeValueCell(row);
    this.addTimeValueCell(row);
    this.addTimeValueCell(row);
};

LeaveHTMLPreviewTimeOnlyStrategy.prototype.getStrategyCssClass = function ()
{
    return "leaveTimeOnly";
};



// WEBPACK FOOTER //
// ./web/js/reports/preview/html/leave/LeaveHTMLPreviewTimeOnlyStrategy.js